'use strict';

import { PushNotificationsService } from './push-notifications.service';
import { PushNotificationsPanelService } from './mx-push-notifications-panel/mx-push-notifications-panel.service';
import PushNotificationsMonitorComponent from './mx-push-notifications-monitor/mx-push-notifications-monitor.component';
import PushNotificationsPanelComponent from './mx-push-notifications-panel/mx-push-notifications-panel.component';

export default angular
	.module('mx.sb.PushNotifications', [
		/*'mx.shell', 'mx.SolutionBuilderAgent'*/
	])
	.service('mx.sb.PushNotifications.NotificationsService', PushNotificationsService)
	.service('mx.sb.PushNotifications.PanelService', PushNotificationsPanelService)
	.component('mxPushNotificationsMonitor', PushNotificationsMonitorComponent)
	.component('mxPushNotificationsPanel', PushNotificationsPanelComponent).name;
